// extracted by mini-css-extract-plugin
module.exports = {"body":"idt-modalbody_body__dagrl","scrollContainer":"idt-modalbody_scrollcontainer__1x8wo"};